// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xCheckoutInnerContainerStyles } from "@pace/App/SharedStyles/CheckoutPageStyles";
import { shippingInfoStyles } from "@pace/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color } from "@pace/XDL/Utilities";
import { css } from "styled-components";

shippingInfoStyles.wrapper = {
    css: css`
        padding-top: 24px;
        margin-top: 4px;
        border-top: 1px solid ${color("common.border")};
        display: block;
        width: 100%;
        float: left;
    `,
};
shippingInfoStyles.container = xCheckoutInnerContainerStyles.container;
shippingInfoStyles.section = xCheckoutInnerContainerStyles.section;
shippingInfoStyles.sectionTwoColums = xCheckoutInnerContainerStyles.sectionTwoColums;
shippingInfoStyles.sectionTitle = xCheckoutInnerContainerStyles.sectionTitle;
shippingInfoStyles.hr = xCheckoutInnerContainerStyles.hr;
shippingInfoStyles.value = xCheckoutInnerContainerStyles.value;

shippingInfoStyles.billingAddress = {
    heading: {
        variant: "h6",
        weight: fontConfig.weight.bold,
        css: css`
            margin-bottom: 12px;
        `,
    },
    editLink: {
        css: css`
            display: none;
        `,
    },
};
